const COMING_SOON_COPY_KEYS = {
  buttonText: "early_access_header_preview_button",
};

const EARLY_ACCESS_COPY_KEYS = {
  buttonText: "early_access_header_shop_button",
};

const getCopyKeys = (isComingSoon) =>
  isComingSoon ? COMING_SOON_COPY_KEYS : EARLY_ACCESS_COPY_KEYS;

export default getCopyKeys;
